import { AnyAction } from 'redux'
import { createAction } from 'redux-actions'
import { ThunkDispatch } from 'redux-thunk'
import { RootState } from '../reducers'
import { MobileAccountService } from '../../api/base/account/mobile_account'
import { OrganizationService } from '../../api/base/organization/organization'
import { post, url, postNoToken } from '../../javascripts/http'
import { AccountType, isHasBasicInfo, verifyTelcodeOrEmail } from '../../javascripts/generic'
import getMenuDataByName from '../../javascripts/menu'
import { message } from 'antd'
import { Modal } from 'antd'
import { OrganizationType, ScannerService } from '../../api/scanner/scanner_service'
import moment from 'moment'
import { MobileCaptchaService, TemplateType } from '../../api/base/captcha/mobile_captcha'
import { PersonaService } from '../../api/base/persona/persona'
import { AccountService } from '../../api/sennotech/scanner/v2/account'
import { InstitutionService } from '../../api/sennotech/scanner/v2/institution'
import { LicenseService } from '../../api/sennotech/scanner/v2/license'
import { LoginDevice } from '../../javascripts/public'
import { StoreService } from '../../api/sennotech/scanner/v2/store'
import { StatisticsService } from '../../api/sennotech/scanner/v2/statistics'

let organizationService = new OrganizationService(url, post);
let mobileAccountService = new MobileAccountService(url, post);
let mobileAccountServiceNoToken = new MobileAccountService(url, postNoToken);
let scannerService = new ScannerService(url, post);
let mobileCaptchaServiceNoToken = new MobileCaptchaService(url, postNoToken);
let personalService = new PersonaService(url, post);
let statisticsService = new StatisticsService(url, post)

const accountServiceNoToken = new AccountService(url, postNoToken);
const institutionService = new InstitutionService(url, post);
const storeService = new StoreService(url, post);
const licenseService = new LicenseService(url, post);

message.config({
    duration: 0,
    maxCount: 3
});

var COS = require('cos-js-sdk-v5');

// 登录 机构
export function actionLoginEntryIns (data, isCaptcha) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        message.loading('正在登陆...', 0);
        try {
            let accessToken;
            let activated = true;
            if(!isCaptcha) {
                let sdata = {
                    mobileNumber: data.username.trim(),
                    password: data.password.trim(),
                    countryCode: '86',
                    client: 'scanner_institution'
                }
                let res = await mobileAccountServiceNoToken.loginByPassword(sdata);
                accessToken = res.accessToken;
            }
            else {
                let sdata = {
                    mobileNumber: data.mobileNumber.trim(),
                    captcha: data.captcha.trim(),
                    countryCode: '86',
                    client: 'scanner_institution'
                }
                let res = await mobileAccountServiceNoToken.loginByCaptcha(sdata);
                accessToken = res.accessToken;
                // 查看账户是否有密码 会加上
            }
            if(!accessToken || !activated) {
                // 账号没注册
                message.destroy();
                // message.error('登录失败!', 0)
                dispatch(actionLoginEntryInsFail({
                    data: '账号不存在，请先注册'
                }))
                return ;
            }
            localStorage.setItem('accessToken', accessToken);

            let res_group = await organizationService.getAccountGroupContext({});
            let ids: number[] = [];
            res_group.accountGroups.map((item) => {
                if(item.name === 'admin' || item.name === 'superAdmin') {
                    ids.push(item.organizationId)
                }
            });

            ids = Array.from(new Set(ids));
            let res_org = await organizationService.getOrganizationByIds({
                ids: ids
            });
            let orgList = res_org.organizations.filter((item) => {
                return item.type  === 'scanner.institution'
            }) || [];

            console.log({orgList})
            if(orgList.length == 0) {
                // 没登录权限
                message.destroy();
                dispatch(actionLoginEntryInsFail({
                    data: '没有加入机构，请先加入机构!'
                }))
                return ;
            }

            dispatch(actionLoginEntryInsSuccess({
                accessToken: accessToken,
                orgList: orgList,
                accountGroups: res_group.accountGroups,
            }))
            message.destroy();

        } catch (error: any) {
            message.destroy();
            if(error.response.headers['senno-exception-message'] === 'CaptchaIsNotCorrect') {
                dispatch(actionLoginEntryInsFail({
                    data: '验证码错误'
                }))
            }
            else if(error.response.headers['senno-exception-message'] === 'AccountNotExist') {
                dispatch(actionLoginEntryInsFail({
                    data: '账号不存在，请先注册'
                }))
            }
            else if(error.response.headers['senno-exception-message'] === 'Wrong Password') {
                dispatch(actionLoginEntryInsFail({
                    data: '密码错误'
                }))
            }
            else {
                dispatch(actionLoginEntryInsFail({
                    data: '登录失败'
                }))
            }
            console.log({error})

        }
    }
}

export const ACTION_LOGINENTRYINS_SUCCESS = 'USER.ACTION_LOGINENTRYINS_SUCCESS'

export interface ActionLoginEntryInsPayload {
    accessToken: any
    orgList: any
    accountGroups: any
}

export const actionLoginEntryInsSuccess = createAction(
    ACTION_LOGINENTRYINS_SUCCESS,
    (payload: ActionLoginEntryInsPayload) => {
        return payload
    }
)

// 登录 机构 四立柱
export function actionLoginSilizhuEntryIns (data, isCaptcha) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        message.loading('正在登陆...', 0);
        try {
            let accessToken;
            if(!isCaptcha) {
                let reg = verifyTelcodeOrEmail(data.username);
                if(!reg.vaild) {
                    dispatch(actionLoginEntryInsFail({
                        data: "账号格式错误"
                    }));
                    return ;
                }
                if(reg.type === AccountType.MOBILENUMBER) {
                    let sdata = {
                        mobileNumber: data.username.trim(),
                        password: data.password.trim(),
                        countryCode: '86',
                        client: 'scannerv2.institution'
                    }
                    let res = await accountServiceNoToken.loginByMobileNumberAndPassword(sdata)
                    accessToken = res.accessToken;
                }
                else {
                    let sdata = {
                        email: data.username.trim(),
                        password: data.password.trim(),
                        client: 'scannerv2.institution'
                    }
                    let res = await accountServiceNoToken.loginByEmailAndPassword(sdata)
                    accessToken = res.accessToken;
                }
                
            }
            else {
                let sdata = {
                    mobileNumber: data.mobileNumber.trim(),
                    captcha: data.captcha.trim(),
                    countryCode: '86',
                    client: 'scannerv2.institution'
                }
                let res = await accountServiceNoToken.loginByMobileNumberAndCaptcha(sdata)
                accessToken = res.accessToken;
                // 查看账户是否有密码 会加上
            }

            if(!accessToken) {
                // 账号没注册
                message.destroy();
                // message.error('登录失败!', 0)
                dispatch(actionLoginEntryInsFail({
                    data: '账号不存在，请先注册'
                }))
                return ;
            }
            localStorage.setItem('accessToken', accessToken);

            let res_ins = await institutionService.listMyInstitutions({})
            if(res_ins.institutions.length == 0) {
                // 没登录权限
                message.destroy();
                dispatch(actionLoginEntryInsFail({
                    data: '没有加入机构，请先加入机构!'
                }))
                return ;
            }

            dispatch(actionLoginSilizhuEntryInsSuccess({
                accessToken: accessToken,
                orgList: res_ins.institutions,
            }))
            message.destroy();

        } catch (error: any) {
            message.destroy();
            if(error.response.headers['senno-exception-message'] === 'CaptchaIsNotCorrect') {
                dispatch(actionLoginEntryInsFail({
                    data: '验证码错误'
                }))
            }
            else if(error.response.headers['senno-exception-message'] === 'AccountNotExist') {
                dispatch(actionLoginEntryInsFail({
                    data: '账号不存在，请先注册'
                }))
            }
            else if(error.response.headers['senno-exception-message'] === 'Wrong Password') {
                dispatch(actionLoginEntryInsFail({
                    data: '密码错误'
                }))
            }
            else {
                dispatch(actionLoginEntryInsFail({
                    data: '登录失败'
                }))
            }
            console.log({error})

        }
    }
}

export const ACTION_LOGINSILIZHUENTRYINS_SUCCESS = 'USER.ACTION_LOGINSILIZHUENTRYINS_SUCCESS'

export interface ActionLoginSilizhuEntryInsPayload {
    accessToken: any
    orgList: any
}

export const actionLoginSilizhuEntryInsSuccess = createAction(
    ACTION_LOGINSILIZHUENTRYINS_SUCCESS,
    (payload: ActionLoginSilizhuEntryInsPayload) => {
        return payload
    }
)

export const ACTION_LOGINENTRYINS_FAIL = 'USER.ACTION_LOGINENTRYINS_FAIL'

export interface ActionLoginEntryInsFailPayload {
    data: any
}

export const actionLoginEntryInsFail = createAction(
    ACTION_LOGINENTRYINS_FAIL,
    (payload: ActionLoginEntryInsFailPayload) => {
        return payload
    }
)


// 登录 商家
export function actionLoginEntryMerchant (data, isCaptcha) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        message.loading('正在登陆...', 0);
        try {
            let accessToken;
            let activated = true;
            if(!isCaptcha) {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
                let sdata = {
                    mobileNumber: data.username,
                    password: data.password,
                    countryCode: '86',
                    client: 'scanner_institution_store'
                }
                let res = await mobileAccountServiceNoToken.loginByPassword(sdata);
                accessToken = res.accessToken;
            }
            else {
                let sdata = {
                    mobileNumber: data.mobileNumber,
                    captcha: data.captcha,
                    countryCode: '86',
                    client: 'scanner_institution_store'
                }
                let res = await mobileAccountServiceNoToken.loginByCaptcha(sdata);
                accessToken = res.accessToken;
                // 查看账户是否有密码 会加上
            }
            if(!accessToken || !activated) {
                // 账号没注册
                message.destroy();
                // message.error('登录失败!', 0)
                dispatch(actionLoginEntryInsFail({
                    data: '账号不存在，请先注册'
                }))
                return ;
            }
            localStorage.setItem('accessToken', accessToken);

            let res_group = await organizationService.getAccountGroupContext({});
            let ids: number[] = [];
            res_group.accountGroups.map((item) => {
                if(item.name === 'admin' || item.name === 'superAdmin' 
                    || item.name === 'staff') {
                    ids.push(item.organizationId)
                }
            });

            ids = Array.from(new Set(ids));
            let res_org = await organizationService.getOrganizationByIds({
                ids: ids
            });

            let orgList = res_org.organizations.filter((item) => {
                return item.type  === 'scanner.institution.store'
            }) || [];

            if(orgList.length == 0) {
                // 没登录权限
                message.destroy();
                dispatch(actionLoginEntryInsFail({
                    data: '没有加入商户，请先加入商户!'
                }))
                return ;
            }

            dispatch(actionLoginEntryMerchantSuccess({
                accessToken: accessToken,
                orgList: orgList,
                accountGroups: res_group.accountGroups,
            }))
            message.destroy();

        } catch (error: any) {
            message.destroy();
            if(error.response.headers['senno-exception-message'] === 'CaptchaIsNotCorrect') {
                dispatch(actionLoginEntryInsFail({
                    data: '验证码错误'
                }))
            }
            else if(error.response.headers['senno-exception-message'] === 'AccountNotExist') {
                dispatch(actionLoginEntryInsFail({
                    data: '账号不存在，请先注册'
                }))
            }
            else if(error.response.headers['senno-exception-message'] === 'Wrong Password') {
                dispatch(actionLoginEntryInsFail({
                    data: '密码错误'
                }))
            }
            else {
                dispatch(actionLoginEntryInsFail({
                    data: '登录失败'
                }))
            }
            console.log(error)
        }
    }
}

export const ACTION_LOGINENTRYMERCHANT_SUCCESS = 'USER.ACTION_LOGINENTRYMERCHANT_SUCCESS'

export interface ActionLoginEntryMerchantPayload {
    accessToken: any
    orgList: any
    accountGroups: any
}

export const actionLoginEntryMerchantSuccess = createAction(
    ACTION_LOGINENTRYMERCHANT_SUCCESS,
    (payload: ActionLoginEntryMerchantPayload) => {
        return payload
    }
)

// 登录 商家 四立柱
export function actionLoginSilizhuEntryMerchant (data, isCaptcha) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        message.loading('正在登陆...', 0);
        try {
            let accessToken;
            if(!isCaptcha) {
                let reg = verifyTelcodeOrEmail(data.username);
                if(!reg.vaild) {
                    dispatch(actionLoginEntryInsFail({
                        data: "账号格式错误"
                    }));
                    return ;
                }
                if(reg.type === AccountType.MOBILENUMBER) {
                    let sdata = {
                        mobileNumber: data.username.trim(),
                        password: data.password.trim(),
                        countryCode: '86',
                        client: 'scannerv2.store'
                    }
                    let res = await accountServiceNoToken.loginByMobileNumberAndPassword(sdata)
                    accessToken = res.accessToken;
                }
                else {
                    let sdata = {
                        email: data.username.trim(),
                        password: data.password.trim(),
                        client: 'scannerv2.store'
                    }
                    let res = await accountServiceNoToken.loginByEmailAndPassword(sdata)
                    accessToken = res.accessToken;
                }
            }
            else {
                let sdata = {
                    mobileNumber: data.mobileNumber.trim(),
                    captcha: data.captcha.trim(),
                    countryCode: '86',
                    client: 'scannerv2.store'
                }
                let res = await accountServiceNoToken.loginByMobileNumberAndCaptcha(sdata)
                accessToken = res.accessToken;
                // 查看账户是否有密码 会加上
            }

            if(!accessToken) {
                // 账号没注册
                message.destroy();
                // message.error('登录失败!', 0)
                dispatch(actionLoginEntryInsFail({
                    data: '账号不存在，请先注册'
                }))
                return ;
            }
            localStorage.setItem('accessToken', accessToken);

            let res_mer = await storeService.listMyStores({})
            if(res_mer.stores.length == 0) {
                // 没登录权限
                message.destroy();
                dispatch(actionLoginEntryInsFail({
                    data: '没有加入店铺，请先加入店铺!'
                }))
                return ;
            }

            dispatch(actionLoginSilizhuEntryMerchantSuccess({
                accessToken: accessToken,
                orgList: res_mer.stores,
            }))
            message.destroy();

        } catch (error: any) {
            message.destroy();
            if(error.response.headers['senno-exception-message'] === 'CaptchaIsNotCorrect') {
                dispatch(actionLoginEntryInsFail({
                    data: '验证码错误'
                }))
            }
            else if(error.response.headers['senno-exception-message'] === 'AccountNotExist') {
                dispatch(actionLoginEntryInsFail({
                    data: '账号不存在，请先注册'
                }))
            }
            else if(error.response.headers['senno-exception-message'] === 'Wrong Password') {
                dispatch(actionLoginEntryInsFail({
                    data: '密码错误'
                }))
            }
            else {
                dispatch(actionLoginEntryInsFail({
                    data: '登录失败'
                }))
            }
            console.log({error})

        }
    }
}

export const ACTION_LOGINSILIZHUENTRYMERCHANT_SUCCESS = 'USER.ACTION_LOGINSILIZHUENTRYMERCHANT_SUCCESS'

export interface ActionLoginSilizhuEntryMerchantPayload {
    accessToken: any
    orgList: any
}

export const actionLoginSilizhuEntryMerchantSuccess = createAction(
    ACTION_LOGINSILIZHUENTRYMERCHANT_SUCCESS,
    (payload: ActionLoginSilizhuEntryMerchantPayload) => {
        return payload
    }
)


export const ACTION_LOGOUT_SUCCESS = 'USER.ACTION_LOGOUT_SUCCESS';

export interface ActionLogoutSuccessPayload {
   
}

export const actionLogoutSuccess = createAction(
    ACTION_LOGOUT_SUCCESS,
    (payload: ActionLogoutSuccessPayload) => {
        localStorage.removeItem('hasStatisticsData');
        return payload;
    }
)

// 确认进入商家 or 机构
export function actionSureOrg (data) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        message.loading('数据加载中...', 0)
        try {

            localStorage.setItem('orgId', data.id.toString());
            let accountGroups = getState().user.accountGroups || [];
            let acc = accountGroups.find((item) => {
                return item.organizationId == data.id
            });
            let role = acc ? acc.name : '';
            localStorage.setItem('role', role);
            dispatch(actionSureOrgSuccess({
                org: data,
                orgId: data.id,
                role: role,
            }))

            let loginDevice = getState().user.loginDevice;
            if(loginDevice === LoginDevice.SCANNER) {
                await dispatch(actionGetMenuAndOrg(data.id, role));
            }
            else {
                await dispatch(actionGetSilizhuMenuAndOrg(data));
            }
            

        } catch(error) {
            console.log(error);
        }
        message.destroy();
    }
}

export const ACTION_SUREORG_SUCCESS = 'USER.ACTION_SUREORG_SUCCESS';

export interface ActionSureOrgSuccessPayload {
    org: any
    orgId: any
    role: string
}

const actionSureOrgSuccess = createAction(
    ACTION_SUREORG_SUCCESS,
    (payload: ActionSureOrgSuccessPayload) => {
        return payload
    }
);

// 发送验证码
export function actionSendCaptcha (mobileNumber, isRegister?) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        try {

            let templateType = TemplateType.GENERAL;
            if(isRegister) {
                templateType = TemplateType.REGISTER;
            }
            await mobileCaptchaServiceNoToken.generate({
                mobileNumber: mobileNumber.trim(),
                countryCode: '86',
                templateType: templateType
            });
            
            dispatch(actionSendCaptchaSuccess({
                data: {},
            }))
            message.success('验证码已发送, 请查收', 6)
        } catch(error) {
            message.error('验证码发送失败, 请稍后重试', 8)
            console.log(error);
        }
    }
}

export const ACTION_SENDCAPTCHA_SUCCESS = 'USER.ACTION_SENDCAPTCHA_SUCCESS';

export interface ActionSendCaptchaSuccessPayload {
    data: any
}

const actionSendCaptchaSuccess = createAction(
    ACTION_SENDCAPTCHA_SUCCESS,
    (payload: ActionSendCaptchaSuccessPayload) => {
        return payload
    }
);

// 修改密码
export function actionChangePassword(data) {
    return async (dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if (!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({
                loginStatus: false
            }))
            return;
        }
        try {
            
            let dataArg = {
                countryCode: '86',
                mobileNumber: data.phone,
                captcha: data.captcha,
                password: data.newPassword
            }
            await mobileAccountService.setPasswordForMobile(dataArg)
           
            dispatch(actionChangePasswordSuccess({
                menuData: {}
            }))
            Modal.success({
                content: '密码修改成功',
            })
            // message.success('修改成功', 3)

        } catch (error) {
            console.log(error);
        }
    }
}

export const ACTION_CHANGEPASSWORD_SUCCESS = 'USER.ACTION_CHANGEPASSWORD_SUCCESS';

export interface ActionChangePasswordSuccessPayload {
    menuData: any
}
const actionChangePasswordSuccess = createAction(
    ACTION_CHANGEPASSWORD_SUCCESS,
    (payload: ActionChangePasswordSuccessPayload) => {
        return payload
    }
);

// 注册
export function actionRegister (data, isIns) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        try {

            let client = 'scanner_institution_store';
            if(isIns) {
                client = 'scanner_institution';
            }
            // 判断是否注册
            let res_reg = await mobileAccountService.isRegistered({
                mobileNumber: data.mobileNumber,
                countryCode: '86'
            });
               
            if(res_reg.isRegistered) {  // 已经注册
                if(res_reg.activated) { // 已经激活
                    let res_ex = await mobileAccountService.checkPasswordExistByClient({
                        mobileNumber: data.mobileNumber,
                        countryCode: '86',
                        client: 'scanner.institution'
                    });
                    // 判断密码是否存在 
                    if(res_ex.exist) { // 有密码
                        dispatch(actionRegisterFail({
                            data: '账号已存在, 请登录'
                        }))
                    }
                    else { // 无密码
                        // 设置密码
                        await mobileAccountService.setPasswordForMobile({
                            mobileNumber: data.mobileNumber,
                            countryCode: '86',
                            captcha: data.captcha,
                            password: data.password,
                        })
                        dispatch(actionRegisterSuccess({
                            data: {},
                        }))
                        // modalRegisterSuccess();
                        Modal.info({
                            title: '注册成功',
                            content: '请联系平台管理员将您添加至平台'
                        })
                    }
                }
                else { // 没有激活
                    await mobileAccountService.activateAccountByMobileNumberAndCaptcha({
                        mobileNumber: data.mobileNumber,
                        countryCode: '86',
                        captcha: data.captcha,
                    });
                    dispatch(actionRegisterSuccess({
                        data: {},
                    }))
                    Modal.info({
                        title: '注册成功',
                        content: '请联系平台管理员将您添加至平台'
                    })
                }
                
            }
            else {
                // 没有注册
                await mobileAccountService.registerByPassword({
                    mobileNumber: data.mobileNumber,
                    captcha: data.captcha,
                    password: data.password,
                    client: client,
                    countryCode: '86'
                })
                dispatch(actionRegisterSuccess({
                    data: {},
                }))
                Modal.info({
                    title: '注册成功',
                    content: '请联系平台管理员将您添加至平台'
                })
            } 
        } catch (error: any) {
            if(error.response.headers['senno-exception-message'] === 'CaptchaIsNotCorrect') {
                dispatch(actionRegisterFail({
                    data: '验证码错误'
                }))
            }
            else if(error.response.headers['senno-exception-message'] === 'AccountAlreadyExist') {
                dispatch(actionRegisterFail({
                    data: '账号已存在'
                }))
            }
            else if(error.response.headers['senno-exception-message']) {
                dispatch(actionRegisterFail({
                    data: error.response.headers['senno-exception-message']
                }))
            }
            else {
                dispatch(actionRegisterFail({
                    data: '注册失败'
                }))
            }
            console.log(error);
        }
    }
}

export const ACTION_REGISTER_SUCCESS = 'USER.ACTION_REGISTER_SUCCESS';

export interface ActionRegisterSuccessPayload {
    data: any
}

const actionRegisterSuccess = createAction(
    ACTION_REGISTER_SUCCESS,
    (payload: ActionRegisterSuccessPayload) => {
        return payload
    }
);


export const ACTION_REGISTER_FAIL = 'USER.ACTION_REGISTER_FAIL';

export interface ActionRegisterFailPayload {
    data: any
}

export const actionRegisterFail = createAction(
    ACTION_REGISTER_FAIL,
    (payload: ActionRegisterFailPayload) => {
        return payload
    }
);

// 重置密码
export function actionResetPassword (data) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        try {

            await mobileAccountService.setPasswordForMobile({
                mobileNumber: data.mobileNumber,
                captcha: data.captcha,
                password: data.password,
                countryCode: '86'
            })
            
            dispatch(actionResetPasswordSuccess({
                data: {},
            }))
            Modal.success({
                title: '重置密码成功',
                content: '现在去点击登录, 可输入账号密码登录啦'
            })
        } catch(error) {
            message.error('重置密码失败', 8)
            console.log(error);
        }
    }
}

export const ACTION_RESETPASSWORD_SUCCESS = 'USER.ACTION_RESETPASSWORD_SUCCESS';

export interface ActionResetPasswordSuccessPayload {
    data: any
}

const actionResetPasswordSuccess = createAction(
    ACTION_RESETPASSWORD_SUCCESS,
    (payload: ActionResetPasswordSuccessPayload) => {
        return payload
    }
);


//保存用户菜单
export function actionGetMenuAndOrg(orgId?, roles?) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}))
            return ;
        }
        message.loading('数据加载中...', 4)
        try {

            let id = orgId || getState().user.orgId;
            let role = roles || getState().user.role || '';
            let res_org = await organizationService.getOrganizationByIds({
                ids: [+id]
            });

            let orgGroupId = '';
            let routeKey = getState().user.routeKey;
            let insInfo = {};
            if(routeKey === 'institution') {
                let res_group = await organizationService.getOrganizationGroupsByOrganizationId({
                    organizationId: +id
                });
                let orgGroup = res_group.organizationGroups[0];
                if(orgGroup.id) {
                    orgGroupId = orgGroup.id.toString();
                }
            }
            else {
                let res_ins = await scannerService.getInstitutionByStoreId({
                    storeId: +id,
                });
                insInfo = res_ins.institution || {} ;
            }

            let res_time = await scannerService.listOrganizationLicence({
                organizationIds: [+id]
            })

            let orgInfo = res_org.organizations[0] || {};
            let time = res_time.organizationLicenceList[0] || {};
            let validity = 0;
            let now = (new Date()).valueOf();
            if(time.endTimestamp && time.startTimestamp && (now <= +time.endTimestamp)) {
                let t1 = moment(+time.startTimestamp);
                let t2 = moment(+time.endTimestamp);
                validity = t2.diff(t1, 'day');
            }
            Object.assign(orgInfo, time,  {validity})
            
            if(role === 'staff') {
                routeKey += '_invalid';
            }
            else {
                if(validity) {
                    routeKey +='_valid'
                }
                else {
                    routeKey += '_invalid'
                }
            }
            
            let menuData = getMenuDataByName(routeKey)
            
            console.log({
                menuData,
                orgInfo,
                orgGroupId,
                insInfo
            });
            dispatch(actionGetMenuAndOrgSuccess({
                menuData: menuData,
                orgInfo: orgInfo,
                orgGroupId: orgGroupId,
                insInfo: insInfo,
            }))

        } catch(error) {
            console.log(error);
        }
        dispatch(actionOperateUserFail({
            data: ''
        }))
        // message.destroy();
    }
}

export const ACTION_GETMENUANDORG_SUCCESS = 'USER.ACTION_GETMENUANDORG_SUCCESS';

export interface ActionGetMenuAndOrgSuccessPayload {
    menuData: any
    orgInfo: any
    orgGroupId: any
    insInfo: any
}

const actionGetMenuAndOrgSuccess = createAction(
    ACTION_GETMENUANDORG_SUCCESS,
    (payload: ActionGetMenuAndOrgSuccessPayload) => {
        return payload
    }
);

//保存用户菜单 四立柱
export function actionGetSilizhuMenuAndOrg (orgInfo?) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}))
            return ;
        }
        message.loading('数据加载中...', 4)
        try {

            let routeKey = getState().user.routeKey;
            let id = getState().user.orgId;
            if(!orgInfo) {
                orgInfo = await institutionService.getInstitution({
                    institutionId: +id
                })
            }
            // let res_operation = await licenseService.listOperations({})
            // let operationList = res_operation.operations;

            // let operation = operationList.find((item) => {
            //     return item.name == "ORGANIZATION"
            // }) || {} as any;

            let res_license = await licenseService.getOrganizationLicenses({
                organizationId: orgInfo.id,
            })

            let time = res_license.expireTime as any;
            let validity = 0;
            let now = (new Date()).valueOf();
            let end = (new Date(time)).valueOf();

            if((now <= end)) {
                let t1 = moment(now);
                let t2 = moment(end);
                validity = t2.diff(t1, 'day');
            }
            Object.assign(
                orgInfo, 
                {
                    expireTime: end,
                    validity,
                    totalCount: +(res_license.totalCount || "0")
                })
            
            let hasStatisticsData = await checkAndGetHasStatistics(+id, getState().user.routeKey);
            let menuData = getMenuDataByName(routeKey + '_silizhu', hasStatisticsData)
           
            dispatch(actionGetSilizhuMenuAndOrgSuccess({
                menuData: menuData,
                orgInfo: orgInfo,
            }))

        } catch(error) {
            console.log(error);
        }
        dispatch(actionOperateUserFail({
            data: ''
        }))
        // message.destroy();
    }
}

export const ACTION_GETSILIZHUMENUANDORG_SUCCESS = 'USER.ACTION_GETSILIZHUMENUANDORG_SUCCESS';

export interface ActionGetSilizhuMenuAndOrgSuccessPayload {
    menuData: any
    orgInfo: any
}

const actionGetSilizhuMenuAndOrgSuccess = createAction(
    ACTION_GETSILIZHUMENUANDORG_SUCCESS,
    (payload: ActionGetSilizhuMenuAndOrgSuccessPayload) => {
        return payload
    }
);


//获取管理员
export function actionGetAdminInfo() {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}))
            return ;
        }
        try {
            
            let id = getState().user.orgId;
            let res_accountGroup = await organizationService.listAccountsByOrganizationIdsAndAccountGroupName({
                organizationIdList: [+id],
                accountGroupNameList: ['superAdmin', 'admin', 'staff']
            });
            
            let accountGroupList = res_accountGroup.organizationAccountGroupAccountList || [];
            if(accountGroupList.length == 0) return ;

            let adminAccountIds: any[] = [];
            let staffAccountIds: any[] = [];
            let superAdminAccount = 0;
            let adminGroupId = 0;
            let staffGroupId = 0;
            accountGroupList[0].accountGroupAccountList.map((item) => {
                if(item.accountGroup.name == 'superAdmin') {
                    superAdminAccount = item.accountIdList[0];
                }
                else if(item.accountGroup.name === 'admin') {
                    adminGroupId = item.accountGroup.id;
                    adminAccountIds = [...adminAccountIds, ...item.accountIdList]
                }
                else if(item.accountGroup.name === 'staff') {
                    staffGroupId = item.accountGroup.id;
                    staffAccountIds = [...staffAccountIds, ...item.accountIdList];
                }
            })

            let accountIds = [...adminAccountIds, ...staffAccountIds, superAdminAccount];
            accountIds = Array.from(new Set(accountIds));
            let res_mobile = await mobileAccountService.getMobileNumberByAccounts({
                accountIds: accountIds
            });
            let res_account = await personalService.getSocialByAccountIds({
                accountIds: accountIds
            })

            let adminList: any[] = [];
            let superAdmin = {};
            res_mobile.result.map((item) => {
                let account = res_account.socialResults.find((a) => {
                    return a.accountId === item.accountId;
                }) || {};
                if(item.accountId === superAdminAccount) {
                    superAdmin = item;
                    adminList.push({
                        ...item,
                        ...account,
                        roles: '原始管理员',
                    })
                }
                else {
                    let roles: string[] = [];
                    if(staffAccountIds.find((a) => a == item.accountId)) {
                        roles.push('店员');
                    }
                    if(adminAccountIds.find((a) => a == item.accountId)) {
                        roles.push('管理员');
                    }
                    adminList.push({
                        ...item,
                        ...account,
                        roles: roles.join(','),
                    });
                }
                
            }) || {};
            
            dispatch(actionGetAdminInfoSuccess({
                superAdmin: superAdmin,
                adminList: adminList,
                adminGroupId: adminGroupId,
                staffGroupId: staffGroupId
            }))

        } catch(error) {
            console.log(error);
        }
        dispatch(actionOperateUserFail({
            data: ''
        }))
    }
}

export const ACTION_GETADMININFO_SUCCESS = 'USER.ACTION_GETADMININFO_SUCCESS';

export interface ActionGetAdminInfoSuccessPayload {
    superAdmin: any,
    adminList: any
    adminGroupId: any
    staffGroupId: any
}

const actionGetAdminInfoSuccess = createAction(
    ACTION_GETADMININFO_SUCCESS,
    (payload: ActionGetAdminInfoSuccessPayload) => {
        return payload
    }
);

//修改组织信息
async function uploadCos(file) {
    let type = file.type.split('/')[1];
    let time = new Date().getTime();
    let filename = `orgLogo-${time}.${type}`;
    let res_cos = await organizationService.getCosStsCredential4Logo({
        filename: filename
    })

    let expirationTime = +(res_cos.expirationTime || 0) / 1000;
    var cos = new COS({
        getAuthorization: function(options, callback) {
            callback({
                TmpSecretId: res_cos.tmpSecretId,
                TmpSecretKey: res_cos.tmpSecretKey,
                XCosSecurityToken: res_cos.sessionToken,
                ExpiredTime: expirationTime, // 时
            });
        }
    });

    return new Promise((resolve, reject) => {
        cos.putObject({
            Bucket: res_cos.bucket,
            Region: res_cos.region,
            Key: res_cos.key,
            Body: file,
            onProgress: function (info) {
                let progress = JSON.stringify(info);
                console.log({ progress })
            }
        }, function(err, data) {

            console.log({data, err});
            if(err) {
                reject(err)
            }
            else {
                let filePath = `https://${data.Location}`
                resolve(filePath)
            }
        })
    })
}

export function actionUpdateOrgInfo(data, file) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}))
            return ;
        }
        try {
            if(file) {
                let url = await uploadCos(file);
                data.organizationLogo = url;
            }
            await organizationService.updateOrganizationNameAndDescription(data)
            dispatch(actionUpdateOrgInfoSuccess({
                data: {}
            }))
            dispatch(actionGetMenuAndOrg())
            message.success('修改成功', 6);
        } catch (error: any) {
            if(error.response && error.response.headers['senno-exception-message'] === 'organization already existed.') {
                dispatch(actionOperateUserFail({
                    data: '机构名称已存在'
                }))
            }
            else {
                dispatch(actionOperateUserFail({
                    data: '更新失败'
                }))
            }
            console.log(error);
        }
    }
}

export const ACTION_UPDATEORGINFO_SUCCESS = 'USER.ACTION_UPDATEORGINFO_SUCCESS';

export interface ActionUpdateOrgInfoSuccessPayload {
    data: any
}

const actionUpdateOrgInfoSuccess = createAction(
    ACTION_UPDATEORGINFO_SUCCESS,
    (payload: ActionUpdateOrgInfoSuccessPayload) => {
        return payload
    }
);

// 错误提示 user 统一用
export const ACTION_OPERATEUSER_FAIL = 'USER.ACTION_OPERATEUSER_FAIL';

export interface ActionOperateUserFailPayload {
    data: string
}

export const actionOperateUserFail = createAction(
    ACTION_OPERATEUSER_FAIL,
    (payload: ActionOperateUserFailPayload) => {
        return payload
    }
);

// 发送短信
async function sendNote (isRegister, data, route) {
    let organizationType = OrganizationType.ORGANIZATION_TYPE_SENNOTECH_INSTITUTION;
    if(route === 'merchant') { 
        organizationType = OrganizationType.ORGANIZATION_TYPE_SENNOTECH_STORE;
    }
    try {
        if(isRegister) {
            // 已经注册的模版
            await scannerService.sendSmsNotificationWhenAccountRegistered({
                countryCode: '86',
                mobileNumber: data.mobileNumber,
                organizationType: organizationType,
                name: data.name,
                organizationName: data.organizationName,
            });
        }
        else {
            // 没有注册过的模版
            await scannerService.sendSmsNotificationWhenAccountPreRegistration({
                countryCode: '86',
                mobileNumber: data.mobileNumber,
                organizationType: organizationType,
                name: data.name,
                organizationName: data.organizationName,
                // accountGroupName: data.accountGroupName,
                username: data.mobileNumber,
                initPassword: '123456'
            });
        }
    } catch(error) {

    }
}

//添加管理员
export function actionAddAdmin(data) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}))
            return ;
        }
        try {

            let res_account;
            let isRegister = true;
            try {
                // 根据手机号 查用户id
                res_account = await mobileAccountService.getAccountId({
                    mobileNumber: data.mobileNumber,
                    countryCode: '86'
                })
                let res_ex = await mobileAccountService.checkPasswordExistByClient({
                    mobileNumber: data.mobileNumber,
                    countryCode: '86',
                    client: 'scanner.institution'
                });
                if(!res_ex.exist) {
                    isRegister = false;
                    await mobileAccountService.setPasswordForMobile({
                        mobileNumber: data.mobileNumber,
                        countryCode: '86',
                        password: '123456',
                    })
                }

            } catch (error) {
                //密码注册
                isRegister = false;
                res_account = await mobileAccountService.registerByPassword({
                    mobileNumber: data.mobileNumber,
                    countryCode: '86',
                    password: '123456',
                    client: 'scanner.institution.store',
                })
            }

            // 用户组添加用户
            let accountId = res_account.accountId;
            let accountGroupId = getState().user.adminGroupId;
            if(accountGroupId == 0) return ;

            await organizationService.addAccountToAccountGroupByAccountId({
                accountGroupId: accountGroupId,
                accountId: accountId
            })

            if(data.name) {
                // 更新名字
                await personalService.createOrUpdateSocial({
                    socialInfo: {
                        accountId: accountId,
                        realName: data.name,
                        displayName: data.name,
                    }
                })
            }

            dispatch(actionAddAdminSuccess({
                data: {}
            }))

            // 发送短信
            let routeKey = getState().user.routeKey;
            let orgInfo = getState().user.orgInfo;
            let noteData = {
                mobileNumber: data.mobileNumber,
                name: data.name || '',
                organizationName: orgInfo.name,
                accountGroupName: '管理员',
            }
            sendNote(isRegister, noteData, routeKey);

            message.success('添加成功', 6);
            dispatch(actionGetAdminInfo())

        } catch (error: any) {
            if(error.response.headers['senno-exception-message'] === 'account already exists.') {
                dispatch(actionOperateUserFail({
                    data: '帐号已存在!'
                }))
            }
            else if(error.response.headers['senno-exception-message']) {
                dispatch(actionOperateUserFail({
                    data: error.response.headers['senno-exception-message']
                }))
            }
            else{
                dispatch(actionOperateUserFail({
                    data: '添加失败'
                }))
            }
            console.log(error);
        }
    }
}

export const ACTION_ADDADMIN_SUCCESS = 'USER.ACTION_ADDADMIN_SUCCESS';

export interface ActionAddAdminSuccessPayload {
    data: any
}

const actionAddAdminSuccess = createAction(
    ACTION_ADDADMIN_SUCCESS,
    (payload: ActionAddAdminSuccessPayload) => {
        return payload
    }
);

//删除管理员
export function actionDeleteAdmin(data) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}))
            return ;
        }
        try {
            
            let accountGroupId = getState().user.adminGroupId;
            await organizationService.removeAccountFromAccountGroup({
                accountId: data.accountId,
                accountGroupId: accountGroupId
            });

            dispatch(actionDeleteAdminSuccess({
                data: {}
            }))

            message.success('删除成功', 6);
            dispatch(actionGetAdminInfo());

        } catch(error) {
            message.error('删除失败', 8);
            console.log(error);
        }
    }
}

export const ACTION_DELETEADMIN_SUCCESS = 'USER.ACTION_DELETEADMIN_SUCCESS';

export interface ActionDeleteAdminSuccessPayload {
    data: any
}

const actionDeleteAdminSuccess = createAction(
    ACTION_DELETEADMIN_SUCCESS,
    (payload: ActionDeleteAdminSuccessPayload) => {
        return payload
    }
);

//添加店员
export function actionAddStaff(data) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}))
            return ;
        }
        try {

            let res_account;
            let isRegister = true;
            try {
                // 根据手机号 查用户id
                res_account = await mobileAccountService.getAccountId({
                    mobileNumber: data.mobileNumber,
                    countryCode: '86'
                })
                let res_ex = await mobileAccountService.checkPasswordExistByClient({
                    mobileNumber: data.mobileNumber,
                    countryCode: '86',
                    client: 'scanner.institution'
                });
                if(!res_ex.exist) {
                    isRegister = false;
                    await mobileAccountService.setPasswordForMobile({
                        mobileNumber: data.mobileNumber,
                        countryCode: '86',
                        password: '123456',
                    })
                }
                
            } catch (error) {
                //密码注册
                isRegister = false;
                res_account = await mobileAccountService.registerByPassword({
                    mobileNumber: data.mobileNumber,
                    countryCode: '86',
                    password: '123456',
                    client: 'scanner.institution.store',
                })
            }
           

            // 用户组添加用户
            let accountId = res_account.accountId;
            let accountGroupId = getState().user.staffGroupId;
            if(accountGroupId == 0) return ;

            await organizationService.addAccountToAccountGroupByAccountId({
                accountGroupId: accountGroupId,
                accountId: accountId
            })

            if(data.name) {
                // 更新名字
                await personalService.createOrUpdateSocial({
                    socialInfo: {
                        accountId: accountId,
                        realName: data.name,
                        displayName: data.name,
                    }
                })
            }

             // 发送短信
            let routeKey = getState().user.routeKey;
            let orgInfo = getState().user.orgInfo;
            let noteData = {
                mobileNumber: data.mobileNumber,
                name: data.name || '',
                organizationName: orgInfo.name,
                accountGroupName: '店员',
            }
            sendNote(isRegister, noteData, routeKey);

            dispatch(actionAddStaffSuccess({
                data: {}
            }))

            message.success('添加成功', 6);
            dispatch(actionGetAdminInfo())

        } catch (error: any) {
            if(error.response.headers['senno-exception-message'] === 'account already exists.') {
                dispatch(actionOperateUserFail({
                    data: '帐号已存在!'
                }))
            }
            else if(error.response.headers['senno-exception-message']) {
                dispatch(actionOperateUserFail({
                    data: error.response.headers['senno-exception-message']
                }))
            }
            else {
                dispatch(actionOperateUserFail({
                    data: '添加失败'
                }))
            }
            console.log(error);
        }
    }
}

export const ACTION_ADDSTAFF_SUCCESS = 'USER.ACTION_ADDSTAFF_SUCCESS';

export interface ActionAddStaffSuccessPayload {
    data: any
}

const actionAddStaffSuccess = createAction(
    ACTION_ADDSTAFF_SUCCESS,
    (payload: ActionAddStaffSuccessPayload) => {
        return payload
    }
);

//删除店员
export function actionDeleteStaff(data) {
    return async(dispatch: ThunkDispatch<RootState, null, AnyAction>, getState: () => RootState) => {
        if(!isHasBasicInfo()) {
            dispatch(actionLogoutSuccess({}))
            return ;
        }
        try {
            
            let accountGroupId = getState().user.staffGroupId;
            await organizationService.removeAccountFromAccountGroup({
                accountId: data.accountId,
                accountGroupId: accountGroupId
            });

            dispatch(actionDeleteStaffSuccess({
                data: {}
            }))

            message.success('删除成功', 6);
            dispatch(actionGetAdminInfo());

        } catch(error) {
            message.error('删除失败', 8);
            console.log(error);
        }
    }
}

export const ACTION_DELETESTAFF_SUCCESS = 'USER.ACTION_DELETESTAFF_SUCCESS';

export interface ActionDeleteStaffSuccessPayload {
    data: any
}

const actionDeleteStaffSuccess = createAction(
    ACTION_DELETESTAFF_SUCCESS,
    (payload: ActionDeleteStaffSuccessPayload) => {
        return payload
    }
);

// 检查并获取 hasStatistics 状态（优先从 localStorage 获取，没有则请求接口）
async function checkAndGetHasStatistics(orgId: number, routeKey: string): Promise<boolean> {
    if (routeKey !== 'institution') {
        return false;
    }

    const cacheKey = 'hasStatisticsData';
    const cached = localStorage.getItem(cacheKey);
    if (cached !== null) {
        return cached === 'true';
    }

    try {
        const res = await statisticsService.hasStatistics({ organizationId: orgId }) as unknown as boolean;
        const hasStats = res ?? false;
        localStorage.setItem(cacheKey, String(hasStats));
        return hasStats;
    } catch (error) {
        console.log('checkAndGetHasStatistics error:', error);
        return false;
    }
}